import type { Band } from "@/types";

const MESSAGES: Record<Band, string> = {
  morning: "first cup · still brewing",
  midday: "cup #2 · holding steady",
  evening: "refill · the good stuff",
  night: "late-night fuel · cup #4",
};

export const mugMessage = (band: Band): string => MESSAGES[band];
